export const SkillTags: {[skills in SkillCategory]: string[]} = {
  backend: [
    'NodeJS',
    'Python',
    'MySQL',
    'Web Crawler',
    'PostgreSQL',
    'Firebase',
    'NoSQL',
    'Pug',
    'Redis',
  ],
  frontend: [
    'React',
    'Redux',
    'Typescript',
    'HTML/CSS',
    'JQuery',
    'SCSS',
    'Redux Toolkit',
    'RWD',
  ],
  devOps: ['Azure DevOps', 'Docker', 'AWS', 'Vercel'],
}
export const Skills: {[skills in SkillCategory]: string[]} = {
  backend: ['NodeJS', 'Python', 'MySQL', 'Web Crawler'],
  frontend: ['React', 'Redux Toolkit', 'Angular', 'Typescript'],
  devOps: ['AWS', 'GCP', 'Docker', 'PM2'],
}
